// API配置文件 - 统一管理后端地址
// 只需要在这里修改一次，所有页面都会使用新地址

// 后端基础地址配置
const API_CONFIG = {
  // 开发环境地址（本地）
  development: {
    baseURL: 'http://127.0.0.1:5321',
    staticURL: 'http://127.0.0.1:5321'
  },
  // 生产环境地址（使用相对路径，自动匹配当前域名的协议）
  production: {
    baseURL: '',  // 使用相对路径，自动使用当前域名
    staticURL: ''
  }
}

// 当前环境（可以通过环境变量控制，默认使用生产环境）
const currentEnv = process.env.NODE_ENV === 'development' ? 'development' : 'production'

// 导出当前环境的配置
const config = API_CONFIG[currentEnv]

// API接口地址
export const API_BASE_URL = config.baseURL
export const STATIC_BASE_URL = config.staticURL

// 常用API端点
export const API_ENDPOINTS = {
  // 认证相关
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    REGISTER: `${API_BASE_URL}/api/auth/regist`,
    CAPTCHA: `${API_BASE_URL}/api/auth/captcha`,
    CHANGE_PASSWORD: `${API_BASE_URL}/api/auth/changePassword`,  // 修改密码
    LOGOUT: `${API_BASE_URL}/api/auth/logout`  // 退出登录
  },
  
  // 用户相关
  USER: {
    INFO: `${API_BASE_URL}/api/user/info`,
    RECHARGE_LIST: `${API_BASE_URL}/api/user/rechage_list`  // 充值记录
  },
  
  // 校友帮相关
  XYB: {
    GET_USER_LIST: `${API_BASE_URL}/api/xyb/task_list`,
    ADD_USER: `${API_BASE_URL}/api/xyb/add_user`,
    SUBMIT_CHECKIN: `${API_BASE_URL}/api/xyb/submit_checkin`,
    GET_LOGS: `${API_BASE_URL}/api/xyb/get_logs`,
    GET_CONFIG: `${API_BASE_URL}/api/xyb/get_config`,
    SAVE_CONFIG: `${API_BASE_URL}/api/xyb/save_config`,
    CHANGE_PASSWORD: `${API_BASE_URL}/api/xyb/change_password`,
    DEL_USER: `${API_BASE_URL}/api/xyb/del_user`,
    BUY: `${API_BASE_URL}/api/xyb/buy`
  },
  
  // 公学芸相关（注意：后端暂无gxy模块，使用外部API或需要创建gxy模块）
  GXY: {
    GET_USER_LIST: `${API_BASE_URL}/api/gxy/task_list`,  // 修改为使用本地后端
    ADD_USER: `${API_BASE_URL}/api/gxy/add_user`,  // 添加用户
    GET_ADDED_COUNT: `${API_BASE_URL}/api/gxy/get_added_count`,  // 展示用累计添加数
    NOW_SIGN: `${API_BASE_URL}/api/gxy/now_sign`,  // 立即打卡
    MAKEUP_SIGN: `${API_BASE_URL}/api/gxy/makeup_sign`,  // 历史补卡申请
    GET_MAKEUP_HISTORIES: `${API_BASE_URL}/api/gxy/get_makeup_histories`,  // 近30天考勤和补卡申请
    CHANGE_PASSWORD: `${API_BASE_URL}/api/gxy/change_password`,  // 修改密码
    DEL_USER: `${API_BASE_URL}/api/gxy/del_user`,  // 删除用户
    GET_SIGN_HISTORIES: `${API_BASE_URL}/api/gxy/get_sign_histories`,  // 获取打卡记录
    GET_CONFIG: `${API_BASE_URL}/api/gxy/get_config`,  // 获取配置
    SAVE_CONFIG: `${API_BASE_URL}/api/gxy/save_config`,  // 保存配置
    UPDATE_SIGN_CONFIG: `${API_BASE_URL}/api/gxy/update_sign_config`,  // 更新签到配置
    AI_GENERATE: `${API_BASE_URL}/api/gxy/ai_generate`,  // AI生成报告
    SUBMIT_REPORT: `${API_BASE_URL}/api/gxy/submit_report`,  // 提交报告
    GET_REPORT: `${API_BASE_URL}/api/gxy/get_report`,  // 获取报告
    GET_WEEKS_DATE: `${API_BASE_URL}/api/gxy/get_weeks_date`,  // 获取周次日期
    REFRESH_USER: `${API_BASE_URL}/api/gxy/refresh_user`,  // 刷新用户信息
    SET_PLAN_ID: `${API_BASE_URL}/api/gxy/set_plan_id`,  // 设置计划ID
    CHANGE_BIND_ACCOUNT: `${API_BASE_URL}/api/gxy/change_bind_account`,  // 转移账户
    GET_UPLOAD_TOKEN: `${API_BASE_URL}/api/gxy/get_upload_token`,  // 获取上传token
    SET_UPLOAD_IMGS: `${API_BASE_URL}/api/gxy/set_upload_imgs`,  // 设置上传图片
    GET_SITE_INFO: `${API_BASE_URL}/api/gxy/get_site_info`,  // 获取站点信息
    SEARCH_ADDR: `${API_BASE_URL}/api/gxy/search_addr`,  // 搜索地址
    GENERATE_SHARE_TOKEN: `${API_BASE_URL}/api/gxy/generate_share_token`,  // 生成专属打卡链接
    AUTHORIZE: `${API_BASE_URL}/api/gxy/authorize`,  // 支付宝授权
  },

  // 公开接口（无需登录）
  PUB: {
    SHARE_INFO: `${API_BASE_URL}/api/pub/share_info`,  // 获取专属链接信息
    SHARE_SIGN: `${API_BASE_URL}/api/pub/share_sign`,  // 专属链接打卡
    SHARE_AUTHORIZE: `${API_BASE_URL}/api/pub/share_authorize`,  // 专属链接授权
  },
  
  // 支付相关
  PAY: {
    GET_PRODUCT: `${API_BASE_URL}/api/pay/get_product`,
    BUY: `${API_BASE_URL}/api/pay/buy`,  // 购买套餐
    HUPI_PAY: `${API_BASE_URL}/api/pay/hupi_pay`,  // 虎皮椒支付
    HUPI_PAY_QUERY: `${API_BASE_URL}/api/pay/hupi_pay_query`,  // 虎皮椒支付查询
    RENEW_WECHAT_PAY: `${API_BASE_URL}/api/pay/renew_wechat_pay`,  // 续费微信直接支付
    GET_VIP_STATUS: `${API_BASE_URL}/api/pay/get_vip_status`  // 获取VIP状态
  },
  
  // 设置相关
  SETTING: {
    GET_SETTING: `${API_BASE_URL}/api/setting/get_setting`,
    SET_SETTING: `${API_BASE_URL}/api/setting/set_setting`
  },

  // 系统管理相关
  MANAGER: {
    GET_ALL_USERS: `${API_BASE_URL}/api/manager/get_all_users`,
    GET_ALL_TASKS: `${API_BASE_URL}/api/manager/get_all_tasks`,
    GET_ALL_PAYS: `${API_BASE_URL}/api/manager/get_all_pays`,
    GET_PAYMENT_STATISTICS: `${API_BASE_URL}/api/manager/get_payment_statistics`,
    GET_TODAY_SITE_INCOME: `${API_BASE_URL}/api/manager/get_today_site_income`,
    GET_SITE_GROWTH: `${API_BASE_URL}/api/manager/get_site_growth`,
    EDIT_BALANCE: `${API_BASE_URL}/api/manager/edit_banlance`,
    DELETE_TASK: `${API_BASE_URL}/api/manager/delete_task`,
    EDIT_TASK: `${API_BASE_URL}/api/manager/edit_task`,
    RESET_PASSWORD: `${API_BASE_URL}/api/manager/reset_password`
  },
  
  // 论文生成相关
  LWB: {
    GENERATE_PAPER_CONTENT: `${API_BASE_URL}/api/lwb/generate_paper_content`,
    GENERATE_PAPER_OUTLINE: `${API_BASE_URL}/api/lwb/generate_paper_outline`,  // 生成论文大纲
    GET_PAPER_PROGRESS: `${API_BASE_URL}/api/lwb/get_paper_progress`,
    SAMPLE_DOCUMENT: 'https://docs.qq.com/pdf/DUHZXekFYc1prUU9S'  // 范文样本PDF页面
  },
  
  // 静态资源
  STATIC: {
    GXY_LOGO: `${STATIC_BASE_URL}/imgs/gxy_logo.png`
  }
}

// 超时配置（毫秒）
export const TIMEOUT_CONFIG = {
  DEFAULT: 20000,        // 默认10秒
  TASK_LIST: 15000,      // task_list接口15秒（因为响应较慢）
  UPLOAD: 30000,         // 文件上传30秒
  LONG_RUNNING: 60000    // 长时间运行的接口60秒
}

// 默认导出配置对象
export default {
  API_BASE_URL,
  STATIC_BASE_URL,
  API_ENDPOINTS,
  TIMEOUT_CONFIG
}
